import { put, takeEvery } from 'redux-saga/effects';

import { presenceActions } from 'components/presence/actions/presenceActions';

import { profileActions } from './settingsProfile.actions';

export const profileSagas = [
  takeEvery(
    profileActions.update.type,
    function* ({
      payload: { user },
    }: ReturnType<typeof profileActions.update>) {
      // Disable simultaneous ringing if the user has no phone number
      if (!user.phone_number) {
        yield put(presenceActions.presenceSetSimultaneousRinging(false));
      }
    },
  ),
];
